/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */


import { CircularProgress, Paper, TableContainer } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import VolunteerFilterNoAdd from "../Others/VolunteerFilterNoAdd";
// import VolunteerAdd from "./VolunteerAdd";
// import VolunteerEdit from "./VolunteerEdit";
// import VolunteerProfile from "./VolunteerProfile";
// import HistoryModal from "../modal/HistoryModal";
// import HistoryTableAdd from "./HistoryTable/HistoryTableAdd";
import { Link } from "react-router-dom";
import useCurrentTrials from "../../hooks/useGetAllStudies";
import Pagination from "../table-components/pagination/Pagination";
import TableComp from "../table-components/table/TableComp";
import useGetAllStudies from "../../hooks/useGetAllStudies";

const CurrentStudyList = ({ user }) => {
  const dispatch = useDispatch();

  const [getAllStudiesList, isLoading, isError, error, isSuccess, refetch] =
    useGetAllStudies();

  // function handleEdit(rowData) {
  //   dispatch(handleEditOpen());
  //   dispatch(rowValue(rowData));
  // }
  // function handleView(rowData) {
  //   dispatch(handleViewOpen());
  //   dispatch(rowValue(rowData));
  // }
  // function handleHistory(rowData) {
  //   dispatch(handleHistoryOpenModal());
  //   dispatch(rowValue(rowData));
  // }

  // const n = userData.ugleve_name;

  const columns = React.useMemo(
    () => [
      // {
      //   Header: "SL No.",
      //   Cell: (row) => {
      //     return <div>{Number(row.row.id) + 1}</div>;
      //   },
      //   // Header: "SL No.",
      //   // accessor: "index",
      //   // Cell: (row) => {
      //   //   return <div>{Number(row.row.id) + 1}</div>;
      //   // },
      //   Filter: false,
      // },
      {
        Header: "Study Code",
        accessor: "study_code",
        Filter: false,
      },
      {
        Header: "Protocol Title",
        accessor: "protocol_title",
        Filter: false,
      },

      // {
      //   Header: "Sponsor Name",
      //   accessor: "dob",
      //   Cell: (row) => (
      //     <div>{moment(row.row.original.dob).format("DD MMM YYYY")}</div>
      //   ),
      //   Filter: false,
      // },
      // {
      //   Header: "Sex",
      //   accessor: "sex",
      //   Filter: false,
      // },

      // {
      //   Header: "Occupation",
      //   accessor: "occupation_name",
      //   Filter: false,
      // },

      {
        Header: "See List",
        Filter: false,
        Cell: ({ row }) => (
          <Link
            style={{
              color: "#007bff",
              textDecoration: "none",
            }}
            onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
            onMouseOut={(e) => (e.target.style.textDecoration = "none")}
            to={`/current-studies/${row.original.study_code}`}
          >
            See List
          </Link>
        ),
      },
      // {
      //   Header: "Active Status",
      //   accessor: "active_fg",
      //   Filter: false,
      //   Cell: (row) => (
      //     <div
      //       style={{
      //         marginLeft: "10Px",
      //         display: "flex",
      //         justifyContent: "start",
      //         alignItem: "center",
      //       }}
      //     >
      //       {row.row.original.active_fg === "1" ? (
      //         <StatusContainer>
      //           <ActiveStatus>Active</ActiveStatus>
      //         </StatusContainer>
      //       ) : (
      //         <StatusContainer>
      //           <InactiveStatus>Inactive</InactiveStatus>
      //         </StatusContainer>
      //       )}
      //     </div>
      //   ),
      // },
      // ! action btns
      // {
      //   Header: () => <div style={{ marginLeft: "20px" }}>Action</div>,
      //   accessor: "col5",
      //   Cell: (row) => (
      //     <ButtonGroup
      //       style={{
      //         display: "flex",
      //         justifyContent: "center",
      //       }}
      //     >
      //       //! edit icon
      //       {/* {(user === "Admin" || user === "Developer") && (
      //         <IconButton
      //           size="small"
      //           sx={{ "&:hover": { color: "#2e68e8" } }}
      //           style={{ color: "#2196F3" }}
      //           variant="none"
      //           onClick={() => handleEdit(row.row.original)}
      //         >
      //           <Tooltip title="Update">
      //             <EditIcon
      //               // fontSize="small"
      //               sx={{ fontSize: 18 }}
      //             />
      //           </Tooltip>
      //         </IconButton>
      //       )} */}
      //       {/* <IconButton
      //         size="small"
      //         sx={{ "&:hover": { color: "#2e68e8" } }}
      //         style={{ color: "#2196F3" }}
      //         variant="none"
      //         onClick={() => handleEdit(row.row.original)}
      //       >
      //         <Tooltip title="Update">
      //           <EditIcon
      //             // fontSize="small"
      //             sx={{ fontSize: 18 }}
      //           />
      //         </Tooltip>
      //       </IconButton> */}
      //       {/* <MouseDiv> */}
      //       {/* //! preview details icon */}
      //       <IconButton
      //         size="small"
      //         sx={{ "&:hover": { color: "#2e68e8" } }}
      //         style={{ color: "#189A2E" }}
      //         variant="none"
      //         onClick={() => handleView(row.row.original)}
      //       >
      //         <Tooltip title="Details">
      //           <VisibilityIcon
      //             sx={{ fontSize: 18 }}
      //             // fontSize="small"
      //           />
      //         </Tooltip>
      //       </IconButton>
      //       {/* //! history icon */}
      //       {/* <IconButton
      //         size="small"
      //         sx={{ "&:hover": { color: "#2e68e8" } }}
      //         style={{ color: "#1976D2" }}
      //         variant="none"
      //         onClick={() => handleHistory(row.row.original)}
      //       >
      //         <Tooltip title="Add History">
      //           <HistoryEduIcon
      //             sx={{ fontSize: 18 }}
      //             // fontSize="small"
      //           />
      //         </Tooltip>
      //       </IconButton> */}
      //     </ButtonGroup>
      //   ),
      //   Filter: false,
      //   disableSortBy: true,
      // },
    ],
    []
  );

  // const add = useSelector((state) => state.Modal.add);
  // const edit = useSelector((state) => state.Modal.edit);

  // useEffect(() => {
  //   if (!add) {
  //     refetch();
  //   }
  // }, [add]);

  // useEffect(() => {
  //   if (!edit) {
  //     refetch();
  //   }
  // }, [edit]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data: getAllStudiesList },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );

  const { globalFilter } = state;
  const { pageIndex, pageSize } = state;
  return (
    <>
      {/* search bar */}
      <div>
        <VolunteerFilterNoAdd
          filter={globalFilter}
          setFilter={setGlobalFilter}
        />
      </div>

      {/* table */}
      <TableContainer component={Paper}>
        <TableComp
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />

        {isLoading && (
          <div
            style={
              {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "280px",
              }
              // display:"flex",
            }
          >
            <CircularProgress />
          </div>
        )}

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>

      {/* modals */}

      {/* <AddModal ModalWidth="md" ModalTitle="Add Volunteer Information">
        <VolunteerAdd />
      </AddModal> */}

      {/* <EditModal ModalWidth="md" ModalTitle="Edit Volunteer Information">
        <VolunteerEdit />
      </EditModal> */}

      {/* <ViewModal ModalWidth="md" ModalTitle="Volunteer Profile">
        <VolunteerAttachmentProfile />
      </ViewModal> */}

      {/* <HistoryModal ModalWidth="md" ModalTitle="Volunteer History">
        <HistoryTableAdd />
      </HistoryModal> */}
    </>
  );
};

export default CurrentStudyList;
